import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { STAT_SCOPE_OPTIONS } from '../constants/statScopes';
import { REPORT_WINDOW_OPTIONS } from '../constants/reportWindows';
import { useJurisdictionsCatalog } from '../lib/jurisdictionsCatalog';

/**
 * Pill-style filters for Reports: time window + region scope.
 * @param {{ activeScope: string, activeWindow: string }} props
 */
const ReportsFilterBar = ({ activeScope, activeWindow }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { scopeOptions, loaded } = useJurisdictionsCatalog();
  const options = loaded && scopeOptions?.length ? scopeOptions : STAT_SCOPE_OPTIONS;

  const setParam = (key, value) => {
    const params = new URLSearchParams(location.search);
    params.set(key, value);
    const search = params.toString();
    navigate(`${location.pathname}${search ? `?${search}` : ''}`, { replace: true });
  };

  return (
    <div className="reports-filter-bar">
      <div className="reports-filter-group">
        <span className="reports-filter-label">Time period</span>
        <div className="reports-filter-pills" role="group" aria-label="Comparison time period">
          {REPORT_WINDOW_OPTIONS.map((option) => (
            <button
              key={option.code}
              type="button"
              className={`reports-filter-pill${activeWindow === option.code ? ' reports-filter-pill--active' : ''}`}
              aria-pressed={activeWindow === option.code}
              title={option.description}
              onClick={() => setParam('window', option.code)}
            >
              {option.name}
            </button>
          ))}
        </div>
      </div>

      <div className="reports-filter-group">
        <span className="reports-filter-label">Region</span>
        <div className="reports-filter-pills" role="group" aria-label="Comparison region">
          {options.map((option) => (
            <button
              key={option.code}
              type="button"
              className={`reports-filter-pill${activeScope === option.code ? ' reports-filter-pill--active' : ''}`}
              aria-pressed={activeScope === option.code}
              onClick={() => setParam('scope', option.code)}
            >
              <span className="reports-filter-pill__flag" aria-hidden="true">
                {option.flag}
              </span>
              <span className="reports-filter-pill__text">{option.name}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReportsFilterBar;
